import { Stack, Group, Button } from '@mantine/core';
import React, { useState } from 'react'
import InputField, { InputFieldTypes } from './input_field';
import { useLanguage } from '../contexts/language.context';
import { useMediaQuery } from '@mantine/hooks';
import { phoneCountryCodes } from '../utility/util';
import { CREATE_COMPANY } from '../services/companies';
import { useAuth } from '../contexts/auth.context';
import { showNotification } from '@mantine/notifications';

const NewWorkspace = ({ }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [formData, setFormData] = useState<{
        name: string;
        email: string;
        phone_code: string;
        phone: string;
    }>({
        name: "",
        email: "",
        phone_code: "",
        phone: "",
    });
    const { str } = useLanguage();
    const { loadUserData } = useAuth();
    const isMobile = useMediaQuery('(max-width: 900px)');

    const handleChange = (dt: any) => setFormData(fd => ({ ...fd, ...dt }));

    const handleSave = () => {
        setLoading(true);
        CREATE_COMPANY(formData)
            .then(({ role, company }) => {
                loadUserData(role.id);
            })
            .catch(err => {
                showNotification({ message: err.message });
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return <Stack>
        <InputField
            title={str("NAME")}
            autoComplete="off"
            name="name"
            value={formData?.name}
            onChange={handleChange}
        />
        <InputField
            title={str("EMAIL")}
            name="email"
            autoCapitalize="off"
            value={formData?.email}
            onChange={handleChange}
        />
        <Group style={isMobile ? { display: 'block' } : {}}>
            <InputField
                style={isMobile ? {} : { flex: 0.3 }}
                title={str("COUNTRY")}
                mb="lg"
                name="phone_code"
                autoComplete="tel-country-code"
                fieldType={InputFieldTypes.SELECT}
                value={formData?.phone_code}
                onChange={handleChange}
                options={phoneCountryCodes}
            />
            <InputField
                style={isMobile ? {} : { flex: 0.7 }}
                title={str("PHONE")}
                mb="lg"
                name="phone"
                value={formData?.phone}
                onChange={handleChange}
            />
        </Group>
        <Group justify='flex-end'>
            <Button loading={loading} onClick={handleSave}>{str("SAVE")}</Button>
        </Group>
    </Stack>
}

export default NewWorkspace;